/**
 * Serializes the current model's nodes and edges into a compact JSON object
 * suitable for sending to the LLM as context.  Strips UI-only fields (position,
 * handles, style) and keeps only semantically relevant data.
 *
 * @param {Array} nodes  - ReactFlow node objects from the store
 * @param {Array} edges  - ReactFlow edge objects from the store
 * @returns {{ nodes: Array, edges: Array }}
 */
export function buildContextSchema(nodes, edges) {
  const compactNodes = nodes
    .filter(n => n.type !== 'text') // text notes carry no schema info
    .map(n => ({
      id: n.id,
      type: n.type,
      name: n.data?.name || '',
      description: n.data?.description || undefined,
      fields: (n.data?.fields || []).map(f => {
        const parts = [f.name];
        if (f.isPrimaryKey) parts.push('PK');
        if (f.isForeignKey) parts.push('FK');
        if (f.nullable === false) parts.push('NOT NULL');
        if (f.checkConstraint) parts.push(`CHECK(${f.checkConstraint})`);
        return {
          name: f.name,
          type: f.type,
          flags: parts.slice(1),
          ...(f.checkConstraint ? { checkConstraint: f.checkConstraint } : {})
        };
      }),
      ...(n.data?.sqlDefinition ? { sqlDefinition: n.data.sqlDefinition } : {}),
    }));

  const compactEdges = edges.map(e => ({
    source: nodes.find(n => n.id === e.source)?.data?.name || e.source,
    target: nodes.find(n => n.id === e.target)?.data?.name || e.target,
    sourceId: e.source,
    targetId: e.target,
    cardinality: e.data?.cardinality || '',
    label: e.data?.label || '',
  }));

  return { nodes: compactNodes, edges: compactEdges };
}
